import { FooterStyled } from "../Styles/Footer";
import {
  FaFacebookF,
  FaLinkedin,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";
import { CiCircleAlert } from "react-icons/ci";
import { useContext } from "react";
import { HomeContext } from "../Context/ContextHome";

export const Footer = ({ relative, background }) => {
  const { darkMode } = useContext(HomeContext);

  return (
    <FooterStyled
      relative={relative}
      background={background}
      darkmode={darkMode}
    >
      <span>Copyright © ACLS Tecnologia 2024</span>
      <ul>
        <li>
          <a
            href="https://api.whatsapp.com/send?phone=556235771553&text=Ol%C3%A1!%20Estou%20entrando%20em%20contato%20pelo%20BRK%20Connect."
            target="_blank"
          >
            <FaWhatsapp />
          </a>
        </li>
        <li>
          <a href="https://www.facebook.com/aclstecnologia" target="_blank">
            <FaFacebookF />
          </a>
        </li>
        <li>
          <a href="https://br.linkedin.com/company/aclsconnect" target="_blank">
            <FaLinkedin />
          </a>
        </li>
        <li>
          <a
            href="https://www.youtube.com/channel/UCxWo2TsHhQLewOVXDH6TrqQ"
            target="_blank"
          >
            <FaInstagram />
          </a>
        </li>
        <li>
          <a
            href="https://www.youtube.com/channel/UCxWo2TsHhQLewOVXDH6TrqQ"
            target="_blank"
          >
            <FaYoutube />
          </a>
        </li>
      </ul>
      <a
        href="/docs/Manual_do_Sistema_BRK.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="manual"
      >
        <CiCircleAlert className="iconManual" /> Manual
      </a>
    </FooterStyled>
  );
};
